import React from "react";

export default function NoteJobberPage() {
  return <div></div>;
}
